/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import Script from "next/script";
import {useAppSelector} from "@/app/hooks/redux";

export default function GTag () {
    const {storeConfig} = useAppSelector(state => state.storeConfigReducer);

    if(storeConfig && storeConfig.gtag_enabled !== "0") {
        // Google Analytics 4 option
        if(storeConfig.gtag_type === "analytics4") {
            return <>
                <Script strategy="lazyOnload"
                        src={`https://www.googletagmanager.com/gtag/js?id=${storeConfig.gtag_analytics4_measurement_id}`} />
                <Script id={'ga4'} strategy="lazyOnload">
                    {`window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${storeConfig.gtag_analytics4_measurement_id}', {page_path: window.location.pathname});`}
                </Script>
            </>
        }
        // Google Tag Manager option
        if(storeConfig.gtag_type === "tag_manager") {
            return <>
                <Script id="gtm-init" strategy="lazyOnload">
                    {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${storeConfig.gtag_tag_manager_container_id}');`}
                </Script>
            </>
        }
    }

    return <></>;
}